import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const Wrapper = styled.div`
    padding: 16px;
    background: #f6f8fa;
    border-radius: 8px;
    max-width: 300px;
    width: 100%;
    ${mq.lt.xl} {
        max-width: 285px;
    }

    ${mq.lt.sm} {
        max-width: 100%;
    }

    .title {
        font-weight: 700;
        font-size: 16px;
        line-height: 120%;
    }

    .block-calc {
        margin-top: 12px;
    }

    .information {
        margin-top: 24px;
    }
`;
